(()=>{
    const teams = [
        {
            "team": "Dallas Cowboys",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Dallas_Coyboys.png?v=1764664673"
        },
        {
            "team": "Cincinnati Bengals",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Cincinnati_Bengals.png?v=1764664704"
        },
        {
            "team": "Chicago Bears",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Chicago_Bears.png?v=1764664734"
        },
        {
            "team": "Carolina Panthers",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Carolina_Panthers.png?v=1764664748"
        },
        {
            "team": "Buffalo Bills",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Buffalo_Bills.png?v=1764664765"
        },
        {
            "team": "Arizona Cardinals",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Arizona_Cardinals.png?v=1764664785"
        },
        {
            "team": "New England Patriots",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/New_England_Patriots.png?v=1764664807"
        },
        {
            "team": "Los Angeles Chargers",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Los_Angeles_Chargers.png?v=1764664826"
        },
        {
            "team": "Las Vegas Raiders",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Las_Vegas_Raiders.png?v=1764664837"
        },
        {
            "team": "Kansas City Chiefs",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Kansas_City_Chiefs.png?v=1764669185"
        },
        {
            "team": "Houston Texans",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Houston_Texans.png?v=1764664878"
        },
        {
            "team": "Philadelphia Eagles",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Philadelphia_Eagles.png?v=1764664912"
        },
        {
            "team": "San Francisco 49ers",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/San_Francisco_49ers.png?v=1764664937"
        },
        {
            "team": "Tennessee Titans",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Tennessee_Titans.png?v=1764664967"
        },
        {
            "team": "Seattle Seahawks",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/seattle_seahawks.png?v=1764665012"
        },
        {
            "team": "LA Rams",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/LA_Rams.png?v=1764665035"
        },
        {
            "team": "Pittsburgh Steelers",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Pittsburgh_Steelers.png?v=1764665077"
        },
        {
            "team": "Minnesota Vikings",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Minnesota_Vikings.png?v=1764665104"
        },
        {
            "team": "Miami Dolphins",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Miami_Dolphins.png?v=1764665123"
        },
        {
            "team": "Jacksonville Jaguars",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Jacksonville_Jaguars.png?v=1764665167"
        },
        {
            "team": "New York Jets",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/New_York_Jets.png?v=1764665182"
        },
        {
            "team": "Washington Commanders",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Washington_Commanders.png?v=1764665209"
        },
        {
            "team": "Cleveland Browns",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Cleveland_Browns.png?v=1764665257"
        },
        {
            "team": "Denver Broncos",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Denver_Broncos.png?v=1764665283"
        },
        {
            "team": "Indianapolis Colts",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Indianapolis_Colts.png?v=1764665321"
        },
        {
            "team": "Baltimore Ravens",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Baltimore_Ravens.png?v=1764665344"
        },
        {
            "team": "Detroit Lions",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Detroit_Lions.png?v=1764665365"
        },
        {
            "team": "New Orleans Saints",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/New_Orleans_Saints.png?v=1764665391"
        },
        {
            "team": "Tampa Bay Buccaneers",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Tampa_Bay_Buccaneers.png?v=1764665418"
        },
        {
            "team": "Atlanta Falcons",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Atlanta_Falcons.png?v=1764666903"
        },
        {
            "team": "Green Bay Packers",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/Artboard_27.png?v=1764864143"
        },
        {
            "team": "New York Giants",
            "image": "https://cdn.shopify.com/s/files/1/0353/7249/files/New_York_Giants.png?v=1764665445"
        }
    ]
    const sorted_teams = teams.sort((a, b) => a.team.localeCompare(b.team));

    let selectedTeams = []

    const emailInput = document.getElementById("nfl-customer-email");

    const indeces = new Map();
    const loc = document.getElementById("nfl-teams")
    sorted_teams.forEach((team,index)=>{
        const wrapper = document.createElement("div");
        wrapper.className="nfl-team w-full flex flex-col items-center justify-center h-20"
        wrapper.style.height="120px";
        wrapper.dataset.team = team.team;
        const img = document.createElement("img");
        img.src = team.image;
        img.className = "h-full"
        const name = document.createElement("div");
        name.innerHTML = team.team;
        name.className="text-xs text-center"
        wrapper.append(img);
        wrapper.append(name);
        loc.append(wrapper);

        const initial = team.team[0]
        if(!indeces.has(initial)){
            indeces.set(initial, index)
        }
    })

    const letters = document.querySelectorAll(".nfl-letter");
    letters.forEach((letter)=>{
        const val = letter.dataset.letter;
        if(!indeces.has(val)){
            letter.classList.add("nfl-missing")
        }
    })

    const addTeam = (team) => {
        selectedTeams.push(team)
        sortTeams();
    }   
    const removeTeam = (team) => {
        console.log(team)
        let temp = selectedTeams.filter((item)=>{
            return item != team;
        })
        selectedTeams = temp;
        sortTeams()
    }

    const sortTeams = () => {
        const icons = document.querySelectorAll(".nfl-team");
        const selectedTeamsDiv = document.getElementById("selected-teams-div");
        icons.forEach((icon)=>{
            const teamName = icon.dataset.team;
            if(selectedTeams.some((team)=>{
                return team.includes(teamName)
            })){
                icon.classList.add("selected-team")
            }else{
                icon.classList.remove("selected-team")
            }
        })
        selectedTeamsDiv.innerHTML = "";
        selectedTeams.forEach((team)=>{
            console.log(team)
            const wrapper = document.createElement("div");
            wrapper.dataset.team = team
            wrapper.className="flex flex-col justify-center items-center relative px-2 py-1 w-min selected-team-thing"
            wrapper.style.border = "1px solid #a1a1a1";
            wrapper.style.borderRadius = "0.305rem"
            nameDiv = document.createElement("div");
            nameDiv.style.fontSize = "10px";
            nameDiv.style.lineHeight = "1";
            const imageDiv = document.createElement("div");
            const imageUrl = teams.find((item)=>{
                return item.team == team
            }).image;
            const img = document.createElement("img");
            img.src = imageUrl;
            img.style.height="40px";
            img.style.width="40px";
            imageDiv.append(img);
            const removeDiv = document.createElement("div");
            removeDiv.style.border="1px solid red";
            removeDiv.style.color = "red";
            removeDiv.style.fontSize = "10px";
            removeDiv.style.borderRadius = "999px";
            removeDiv.style.height="24px";
            removeDiv.style.width="24px";
            removeDiv.style.position="absolute";
            removeDiv.style.top="0px"
            removeDiv.style.right="0px"
            removeDiv.style.background="white";
            removeDiv.style.zIndex="10";
            removeDiv.innerHTML = "x"
            removeDiv.style.transform="translate(50%,-50%)";
            removeDiv.style.display = "flex";
            removeDiv.style.alignItems = "center"
            removeDiv.style.justifyContent = "center"
            wrapper.append(imageDiv, nameDiv, removeDiv)

            nameDiv.innerHTML = team;
           selectedTeamsDiv.append(wrapper);
            
        })
        if(selectedTeams.length == 0){
            const a = document.createElement("div");
            a.style.width="100%";
            a.style.textAlign="center";
            a.innerHTML = "Nothing yet!";
            selectedTeamsDiv.append(a)
        }
    }

    const getTeams = async(customerEmail) => {
         const res = await fetch(
            `https://oddballs-data--development.gadget.app/apps/oddballs-data/nfl-teams?email=${customerEmail}`,
            {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
            }
        );
        const fetchedTeams = await res.json();
        fetchedTeams.forEach((team)=>{
            selectedTeams.push(team)
        })
        sortTeams()
    }
    const customerEmail = document.getElementById("customer-email-input")?.value;
    if (customerEmail){
        getTeams(customerEmail)
        emailInput.value=customerEmail
    }

    const submitForm = async () => {
        const button = document.getElementById("nfl-sign-up-button")
        const email = emailInput.value;
        if(!email){
            alert("enter an email silly")
        }else{
           const body = {
                email: email,
                teams: selectedTeams
                };

                const res = await fetch(
                "https://oddballs-data--development.gadget.app/apps/oddballs-data/nfl-preferences",
                {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(body)
                }
                );

                const data = await res.json();
                console.log(data);
        }
    }

    function findClosestSnapIndex(snapIndex) {
        const entries = Array.from(indeces.entries());

        let closest = entries[0];
        let smallestDiff = Infinity;

        for (const [letter, value] of entries) {
            const diff = Math.abs(value - snapIndex);
            if (diff < smallestDiff) {
            smallestDiff = diff;
            closest = [letter, value];
            }
        }

        return closest; 
    }

    document.addEventListener("click", (e)=>{

        if((e).target.closest(".nfl-clear-letter")){
            e.target.closest(".nfl-clear-letter").style.display = "none"
            const prevActive = document.querySelector(".nfl-letter.active");
            prevActive.classList.remove("active");
            const teamDivs = document.querySelectorAll(".nfl-team");
            teamDivs.forEach((team)=>{
                team.classList.remove("hidden");
            })


        }

        if (e.target.closest("#nfl-forward")) {
            document.getElementById("nfl-back").classList.remove("disabled")
                const matrix = new WebKitCSSMatrix(getComputedStyle(loc).transform);
                let x = matrix.m41;
                const step = 84;

                let index = Math.round(-x / step);
                const containerWidth = a.offsetWidth;
                const maxIndex = Math.ceil((loc.scrollWidth - containerWidth) / step);

                index++;
                if(index == maxIndex){
                    e.target.closest("#nfl-forward").classList.add("disabled")
                }else{
                    e.target.closest("#nfl-forward").classList.add("remove")
                }

                if (index > maxIndex) index = maxIndex;

                const snappedX = -(index * step);

                loc.style.transform = `translateX(${snappedX}px)`;

                const negSnap = -snappedX;
                const snapIndex = negSnap / step;
                const b = findClosestSnapIndex(snapIndex);
                const currentLetter = b[0];

                letters.forEach(letter => {
                    letter.classList.remove("active");
                    if (letter.dataset.letter == currentLetter) {
                        letter.classList.add("active");
                    }
                });
            }
        if (e.target.closest("#nfl-back")) {
            document.getElementById("nfl-forward").classList.remove("disabled");
                const matrix = new WebKitCSSMatrix(getComputedStyle(loc).transform);
                let x = matrix.m41;
                const step = 84;

                let index = Math.round(-x / step);
                const containerWidth = a.offsetWidth;

                index--
                if(index == 0){
                    e.target.closest("#nfl-back").classList.add("disabled")
                }else{
                    e.target.closest("#nfl-back").classList.add("remove")
                }

                if (index < 0) index = 0;

                const snappedX = -(index * step);

                loc.style.transform = `translateX(${snappedX}px)`;

                const negSnap = -snappedX;
                const snapIndex = negSnap / step;
                const b = findClosestSnapIndex(snapIndex);
                const currentLetter = b[0];

                letters.forEach(letter => {
                    letter.classList.remove("active");
                    if (letter.dataset.letter == currentLetter) {
                        letter.classList.add("active");
                    }
                });
            }


        if((e).target.closest(".nfl-letter")){
            const letter = e.target.dataset.letter
            // const index = indeces.get(letter);
            // loc.style.transform = `translateX(-${index*84}px)`
            const teamDivs = document.querySelectorAll(".nfl-team");
            teamDivs.forEach((team)=>{
                const teamName = team.dataset.team;
                const teamLetter = teamName[0];
                if (teamLetter == letter){
                    team.classList.remove("hidden");
                }else{
                    team.classList.add("hidden")
                }

            })
            document.querySelector(".nfl-clear-letter").style.display = "flex";
            const prevActive = document.querySelector(".nfl-letter.active");
            if(prevActive){
                prevActive.classList.remove("active");
                console.log("adding active")
            }
            e.target.closest(".nfl-letter").classList.add("active")
        }
        if(e.target.closest(".selected-team-thing")){
            removeTeam(e.target.closest(".selected-team-thing").dataset.team)
        }
        if(e.target.closest(".nfl-team")){
            if(e.target.closest(".selected-team")){
                removeTeam(e.target.closest(".nfl-team").dataset.team)
            }else{
                addTeam(e.target.closest(".nfl-team").dataset.team)
            }
        }
        if(e.target.closest("#nfl-sign-up-button")){
            submitForm()
        }
    })

    const a = document.querySelector(".nfl-teams-wrapper");
    let startX = 0;           
    let startOffset = 0;       
    let isDragging = false;

    // a.addEventListener("touchstart", (e) => {
    // isDragging = true;
    // startX = e.changedTouches[0].clientX;

    // const matrix = new WebKitCSSMatrix(getComputedStyle(loc).transform);
    // startOffset = matrix.m41; 
    // });

    // a.addEventListener("touchmove", (e) => {
    // if (!isDragging) return;

    // const currentX = e.changedTouches[0].clientX;
    // const diff = currentX - startX; 

    // let newPos = startOffset + diff;

    // const maxLeft = 0;
    // const maxRight = -(loc.scrollWidth - a.offsetWidth) - 120;

    // if (newPos > maxLeft) newPos = maxLeft;
    // if (newPos < maxRight) newPos = maxRight;

    // loc.style.transform = `translateX(${newPos}px)`;
    // });

    // a.addEventListener("touchend", () => {
    //     isDragging = false;

    //     const matrix = new WebKitCSSMatrix(getComputedStyle(loc).transform);
    //     let x = matrix.m41;

    //     let index = Math.round(-x / 84);

    //     const maxIndex = Math.ceil((loc.scrollWidth - a.offsetWidth) / 84);
    //     if (index < 0) index = 0;
    //     if (index > maxIndex) index = maxIndex;

    //     const snappedX = -(index * 84);
    //     const negSnap = -snappedX;
    //     const snapIndex = negSnap/84;
    //     const b = findClosestSnapIndex(snapIndex);
    //     const currentLetter = b[0];
    //     letters.forEach((letter)=>{
    //         letter.classList.remove("active")
    //         if(letter.dataset.letter == currentLetter){
    //             letter.classList.add("active")
    //         }
    //     })

    //     loc.style.transform = `translateX(${snappedX}px)`;

    // });

})()
